module.exports = __webpack_public_path__ + "img/party_lower_4.1127fb47.jpg";